export default __webpack_public_path__ + "locales/sl/CreateEditRoomDialog.json?hash=c1950b47e08d024b82242a1e9929a0e9";